import { forwardRef } from 'react';
import TextInternal from './text-internal';
var Text = forwardRef(TextInternal);
export default Text;
